import request from '@/utils/request'

// 客服管理API

// 分页查询客服列表
export function listAgents(params) {
  return request({
    url: '/api/admin/agents',
    method: 'get',
    params
  })
}

// 获取客服详情
export function getAgent(agentId) {
  return request({
    url: `/api/admin/agents/${agentId}`,
    method: 'get'
  })
}

// 创建客服
export function createAgent(data) {
  return request({
    url: '/api/admin/agents',
    method: 'post',
    data
  })
}

// 更新客服
export function updateAgent(agentId, data) {
  return request({
    url: `/api/admin/agents/${agentId}`,
    method: 'put',
    data
  })
}

// 删除客服
export function deleteAgent(agentId) {
  return request({
    url: `/api/admin/agents/${agentId}`,
    method: 'delete'
  })
}

// 重置客服密码
export function resetAgentPassword(agentId) {
  return request({
    url: `/api/admin/agents/${agentId}/reset-password`,
    method: 'post'
  })
}

// 更新客服状态
export function updateAgentStatus(agentId, status) {
  return request({
    url: `/api/admin/agents/${agentId}/status`,
    method: 'put',
    params: { status }
  })
}

// 更新客服权重
export function updateAgentWeight(agentId, weight) {
  return request({
    url: `/api/admin/agents/${agentId}/weight`,
    method: 'put',
    params: { weight }
  })
}

// 更新客服最大并发数
export function updateAgentMaxConcurrent(agentId, maxConcurrent) {
  return request({
    url: `/api/admin/agents/${agentId}/max-concurrent`,
    method: 'put',
    params: { maxConcurrent }
  })
}

// 获取客服当前会话数
export function getCurrentConversationCount(agentId) {
  return request({
    url: `/api/admin/agents/${agentId}/current-conversations`,
    method: 'get'
  })
}
